<style lang="scss">

    h4 {
        color: #fff;
        text-align: center;
    }

</style>

<h4>Cargando...</h4>
